import { editRole } from "app/services/roleService";
import { Formik } from "formik";
import React, { memo } from "react";
import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { NotificationManager } from "react-notifications";
import { RenderTextArea, RenderTextInput } from "app/common/renderInput";
import * as yup from "yup";

const validationModel = yup.object().shape({
  roleName: yup.string().required("Please enter role"),
  description: yup.string().optional(),
  isLocked: yup.boolean().required(),
});

function EditRoles({ row, loadRoles }) {
  const [show, setShow] = useState(false);
  const [isLockedState, setIsLockedState] = useState(row.isLocked);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSearchChanges = () => {
    setIsLockedState(!isLockedState);
  };

  const handleSubmit = async (values, { resetForm }) => {
    const newValue = { ...values, isLocked: isLockedState };

    const response = await editRole(row.roleId, newValue);

    if (response.status == "Success") {
      NotificationManager.success(response.message);

      handleClose();
      loadRoles();

      resetForm();
    } else {
      NotificationManager.error(response.message);
    }
  };

  return (
    <>
      <FaEdit color="primary" onClick={handleShow} className="cursor-pointer" />

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Formik
          initialValues={row}
          validationSchema={validationModel}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => {
            return (
              <form
                className="needs-validation"
                onSubmit={handleSubmit}
                noValidate
              >
                <Modal.Header closeButton>
                  <Modal.Title> Edit Role</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <RenderTextInput
                    type="text"
                    name="roleName"
                    display="Role"
                    value={values.roleName}
                    error={errors.roleName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.roleName}
                    required
                    readOnly
                  ></RenderTextInput>

                  <RenderTextArea
                    name="description"
                    display="Description"
                    value={values.description}
                    error={errors.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.description}
                  ></RenderTextArea>
                  <div className="ml-3">
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label="Lock"
                      name="isLocked"
                      checked={isLockedState}
                      onChange={handleSearchChanges}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary" type="submit">
                    Save
                  </Button>
                </Modal.Footer>
              </form>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
}

export default memo(EditRoles);
